@if (hasAppLinks) {
<div class="container">
<div class="row d-flex align-items-center wrapper">
    <div class="col-md-7 col-12">
        <div class="d-flex content-section justify-content-start">
            <div>
                <app-mini-env-heading-block
                    class="mini-footer-heading"
                    [miniTitle]="'Download App'"
                    [title]="'Take control of your <br> healthcare with our easy to use App'"
                    [description]="'Manage your healthcare anytime, anywhere with ease. Our app keeps everything simple, secure, and within reach.'"
                    [style]="'max-width: 557px;'" [leftAlign]="true"
                    ></app-mini-env-heading-block>

                    <div class="d-flex social-btn-row" style="margin-top: 20px;gap: 15px;">
                        <a *ngIf="appStoreUrl" [href]="appStoreUrl" target="_blank"> 
                            <img [src]="sharedService.imagesUrl + 'icons/app-store-download.svg'" alt="">
                        </a>
                        <a *ngIf="googlePlayUrl" [href]="googlePlayUrl" target="_blank">
                            <img [src]="sharedService.imagesUrl + 'icons/android-download.svg'" alt="">
                        </a>
                    </div>
            </div>
        </div>
    </div>
    <div class="col-md-5 col-12">
        <div class="img-section d-flex" style="margin: 0 auto;">
          <img class="footer-img" [src]="'/assets/tenant-assets/mini-env/images/mini-env-subfooter.png'" style="object-fit: cover;border-radius: 8px;" alt="">
        </div>
    </div>
</div>
</div>
}
